export default __webpack_public_path__ + "static/media/studio3.e19d6f8c.jpeg";